export enum RouterEnum {
  HOME = '/',
  BROKER = '/broker',
  BROKER_BUY = 'buy/commercial-combined',
  BROKER_BUY_COMMERCIAL_COMBINED = ':guid',
  BROKER_REFER = 'refer/:guid',

  BACKOFFICE = '/back-office',
  COMMERCIAL_COMBINED = 'commercial-combined',

  NEW_QUOTE = 'new-quote/buy/commercial-combined',
  NEW_QUOTE_BROKER = ':brokerId/:brokerName',

  NEW_QUOTE_CLIENT = 'new-quote-client',
  NEW_QUOTE_CLIENT_PARAMS = 'new-quote-client',
  NEW_QUOTE_CLIENT_PARAMS_GUID = 'new-quote-client',

  MOTOR_TRADE = '/motortrade',
  MOTOR_TRADE_BUY = 'buy',
}
